/**
 * @description 助力
 * @author Kody
 * @date 2019-08-08
 */
import Api from '../../../path';
import { fetchData } from '@umu/umu-fetch';
import { reportError } from 'common/src/services/errorLogger';

interface IInput {
    privilege_type: string;
}
interface IOutput {
    status: number;
}

export const toExchangePrivilege = (data: IInput): Promise<IResponse<IOutput>> => {
    return fetchData(Api.EXCHANGE_PRIVILEGE, data)
        .then((res: IResponse<IOutput>) => {
            return res;
        })
        .catch((err: any) => {
            reportError({
                error: err,
                componentName: 'toExchangePrivilege',
                props: data,
                additionalInfo: {
                    description: 'toExchangePrivilege fetchData error',
                },
            });
            throw err;
        });
};
